import styled, { css } from 'styled-components/macro';

export const TextStyleP = styled.p`
  ${props =>
    props.color &&
    css`
      color: ${props.theme[props.color]};
    `}
  ${props =>
    props.italics &&
    css`
      font-style: italic;
    `}
`;
